module.exports = __webpack_public_path__ + "static/media/document_white.953539ad.svg";